// Función para obtener las iniciales del nombre
// Retorna null si no puede generar iniciales válidas (para mostrar animación de carga)
export const getInitials = (firstName, lastName) => {
    // Validar que los parámetros existan y sean strings
    const first = typeof firstName === 'string' ? firstName.trim() : '';
    const last = typeof lastName === 'string' ? lastName.trim() : '';

    // Si ambos están vacíos o no son válidos, retornar null para mostrar loading
    if (!first && !last) {
        return null;
    }

    // Si tenemos ambos nombres válidos, usar la primera letra de cada uno
    if (first && last && first.length > 0 && last.length > 0) {
        const firstChar = first[0];
        const lastChar = last[0];
        // Validar que sean letras
        if (/[a-zA-Z]/.test(firstChar) && /[a-zA-Z]/.test(lastChar)) {
            return (firstChar + lastChar).toUpperCase();
        }
    }

    // Si solo tenemos firstName válido, usar las primeras dos letras
    if (first && first.length > 0) {
        const validChars = first.match(/[a-zA-Z]/g);
        if (validChars && validChars.length > 0) {
            return validChars.slice(0, 2).join('').toUpperCase();
        }
    }

    // Si solo tenemos lastName válido, usar las primeras dos letras
    if (last && last.length > 0) {
        const validChars = last.match(/[a-zA-Z]/g);
        if (validChars && validChars.length > 0) {
            return validChars.slice(0, 2).join('').toUpperCase();
        }
    }

    // Si no se pudo generar iniciales válidas, retornar null
    return null;
};